export default "__VITE_ASSET__DtHBBo2g__"